import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

import { ReactComponent as IconDown } from '@/assets/images/icons/icon-down.svg';
// import { ReactComponent as IconInfo } from '@/assets/images/icons/icon-info.svg'

import FormatBuyModal from '@/components/Modals/FormatBuy/FormatBuyModal';
import PartnerInfo from '@/components/Modals/PartnerInfo/PartnerInfo';
import SelectCityModal from '@/components/Modals/SelectCityModal/SelectCityModal';

import { getStoreCities, getStoreFormats, getStoreSelectedCity } from '@/store/slices/app';
import { getRightNames } from '@/utils/common';
import { getCurrentPrice, getFormatTime } from '@/utils/times';

import styles from './Formats.module.scss';

const mainPartner = {
  adInfo: {
    company: 'ПАО "Промсвязьбанк"',
    inn: 7744000912,
    token: '2VtzqxUsFkJ',
  },
};

function Formats({ onChangeCity }) {
  const formats = useSelector(getStoreFormats);
  const cities = useSelector(getStoreCities);
  const selectedCity = useSelector(getStoreSelectedCity);
  const [isSelectCity, setIsSelectCity] = useState(false);
  const [isOpenPopup, setOpenPopup] = useState(false);
  const [format, setFormat] = useState(null);
  const [nextPriceDays, setNextPriceDays] = useState(null);
  const [isOpenPartnerInfo, setIsOpenPartnerInfo] = useState(false);
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  useEffect(() => {
    if (formats?.length > 0) {
      const nextDate = getCurrentPrice(formats[0]?.prices)?.start_date ? getFormatTime(getCurrentPrice(formats[0]?.prices)?.start_date, null, 'YYYY-MM-DD') : null;
      if (nextDate) {
        const difference = +new Date(nextDate) - +new Date();
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));

        setNextPriceDays(days);
      }
    }
  }, [formats]);

  const handleClickBuy = (format) => {
    setFormat(format);
    setOpenPopup(true);
  };

  const handleCloseModal = () => {
    setOpenPopup(false);
    setFormat(null);
  };

  const sortedFormats = formats?.slice().sort((a, b) => (a.price || 0) - (b.price || 0));

  return (
    <section className={styles.formats} id="formats">
      <div className={styles.inner}>
        <div className={styles.top}>
          <h2 className={styles.title}>Дистанции</h2>

          <div className={styles.selectCityWrap}>
            <p>выберите город:</p>
            <button className={styles.city} onClick={() => setIsSelectCity((prev) => !prev)} type="button">
              {selectedCity?.city?.name_ru}
              <IconDown className={styles.iconDown} />
            </button>

            <SelectCityModal
              cities={cities}
              isOpen={isSelectCity}
              onChangeCity={onChangeCity}
              onClose={setIsSelectCity}
              isCenter={isMobile}
              isOverlay={isMobile}
            />
          </div>
        </div>

        <ul className={styles.items}>
          {sortedFormats?.map((format) => (
            <li className={styles.item} key={format.public_id}>
              <div className={styles.itemMain}>
                <div className={styles.itemTop}>
                  <p className={styles.itemTitle}>
                    <span>{format.title}</span>
                    {/* {format.title === 'ПСБ 5 км' && (
                      <button className={styles.btnInfo} onClick={() => setIsOpenPartnerInfo(true)}>
                        <span className="visually-hidden">Информация о партнёре</span>
                        <IconInfo width={20} height={20} />
                      </button>
                    )} */}
                  </p>
                  <p className={styles.price}>{format.price ? `${format.price} ₽.` : ''}</p>
                </div>

                <p className={styles.desc}>{format.description}</p>
                <ul className={styles.requirements}>
                  {format.requirements.map((item) => (
                    <li className={styles.requirement} key={item}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className={styles.buttons}>
                {format.age_min <= 15 && (
                  <a className={styles.link} href="https://забег.рф/soglasie.pdf">
                    Разрешение от родителей
                  </a>
                )}

                {format.tickets_left.athlete < 1 ? (
                  <button
                    className={styles.button}
                    type="button"
                    disabled={true}
                  >
                    Распродано
                  </button>
                ) : (
                  <button
                    className={styles.button}
                    type="button"
                    onClick={() => handleClickBuy(format)}
                  >
                    Выбрать
                  </button>
                )}
              </div>
            </li>
          ))}

          <li className={styles.item}>
            <div className={styles.itemMain}>
              <div className={styles.itemTop}>
                <p className={styles.itemTitle}>Онлайн</p>
                <p className={styles.price}>{'от 720'} ₽.</p>
              </div>

              <p className={styles.desc}>
                Стань частью крупного бегового события вне зависимости от твоего местонахождения
              </p>
            </div>

            <div className={styles.buttons}>
              <a className={styles.button} href="/online">
                Выбрать
              </a>
            </div>
          </li>

          {/*<li className={styles.item}>*/}
          {/*  <div className={styles.itemMain}>*/}
          {/*    <div className={styles.itemTop}>*/}
          {/*      <p className={styles.itemTitle}>участие команд</p>*/}
          {/*    </div>*/}
          {/*  </div>*/}

          {/*  <div className={styles.buttons}>*/}
          {/*    <a className={styles.button} href="https://heroleague.ru/corp#corpForm">*/}
          {/*      Выбрать*/}
          {/*    </a>*/}
          {/*  </div>*/}
          {/*</li>*/}

          <li className={`${styles.item} ${styles.itemCorp}`}>
            <div className={styles.itemMain}>
              <div className={styles.itemTop}>
                <p className={styles.itemTitle}>Корпоративное участие</p>
              </div>
              <p className={styles.desc}></p>
              <ul className={styles.requirements}>
                <li className={styles.requirement}>
                  В вашей компании любят активный отдых и спорт?
                  Присоединяйтесь к участию в самом масштабном и ярком беговом событии вместе с коллегами! Дружеская атмосфера, командный дух и незабываемый опыт.
                </li>
              </ul>
            </div>

            <div className={styles.buttons}>
              {[491422, 524901].includes(selectedCity?.city?.id) ? (
                <a className={styles.button} href="https://heroleague.ru/corp#corpForm" target="_blank" rel="noopener noreferrer">
                  Заполнить заявку
                </a>
              ) : (
                <button
                  className={styles.button}
                  type="button"
                  disabled={true}
                >
                  Распродано
                </button>
              )}
            </div>
          </li>

          <li className={`${styles.item} ${styles.itemMed}`}>
            <div className={styles.itemMain}>
              <div className={styles.itemTop}>
                <p className={styles.itemTitle}>Медицинская справка обязательна!</p>
              </div>
            </div>

            <div className={styles.buttons}>
              <a className={styles.button} href="#medical" type="button">
                Подробнее
              </a>
            </div>
          </li>

          {nextPriceDays > 0 && (
            <li className={`${styles.item} ${styles.itemIncrease}`}>
              <div className={styles.itemMain}>
                <div className={styles.itemTop}>
                  <p className={styles.itemTitle}>
                    Торопись! Цена станет выше через {nextPriceDays}{' '}
                    {getRightNames(nextPriceDays, 'День', 'Дня', 'Дней')}
                  </p>
                </div>
              </div>

              <div className={styles.buttons}>
                <button className={styles.button} type="button">
                  участвовать
                </button>
              </div>
            </li>
          )}
        </ul>
      </div>

      {isOpenPopup && <FormatBuyModal format={format} isOpen={isOpenPopup} onClose={handleCloseModal} />}
      <PartnerInfo partner={mainPartner} isOpen={isOpenPartnerInfo} onClose={() => setIsOpenPartnerInfo(false)} />
    </section>
  );
}

export default Formats;
